import { Advice, AdvisorConfig, ChartId, Datum, FieldInfo, PureChartKnowledge } from '@antv/ava';
import {CustomChartsType} from "../charts";

export type BackEndChartType =
    | 'response_line_chart'
    | 'response_bar_chart'
    | 'response_pie_chart'
    | 'response_scatter_chart'
    | 'response_area_chart'
    | 'response_heatmap_chart'
    | 'response_table';

export type Specification = Advice['spec'] | any;
export type RuleConfig = AdvisorConfig['ruleCfg'];

export type AutoChartProps = {
    data: Datum[];
    /** Chart type which are suggestted. */
    chartType: ChartType[];
    /** Charts exclude or include. */
    scopeOfCharts?: {
        exclude?: string[];
        include?: string[];
    };
    /** Customize rules. */
    ruleConfig?: RuleConfig;
};

export type ChartKnowledge = PureChartKnowledge & { toSpec?: any };

export type CustomChart = {
    /** Chart type ID, unique. */
    chartType: ChartType;
    /** Chart knowledge. */
    chartKnowledge: ChartKnowledge;
    /** Chart name. */
    chineseName?: string;
};

export type GetChartConfigProps = {
    data: Datum[];
    spec: Specification;
    dataProps: FieldInfo[];
    chartType?: ChartType;
};

export type CustomAdvisorConfig = {
    charts?: CustomChart[];
    scopeOfCharts?: {
        exclude?: string[];
        include?: string[];
    };
    ruleConfig?: RuleConfig;
};

export type ChartType = ChartId | CustomChartsType;

export const getChartType = (backendChartType: BackEndChartType): ChartType[] => {
    if (backendChartType === 'response_line_chart') {
        return ['multi_line_chart', 'multi_measure_line_chart'];
    }
    if (backendChartType === 'response_bar_chart') {
        return ['multi_measure_column_chart'];
    }
    if (backendChartType === 'response_pie_chart') {
        return ['pie_chart'];
    }
    if (backendChartType === 'response_scatter_chart') {
        return ['scatter_plot'];
    }
    if (backendChartType === 'response_area_chart') {
        return ['area_chart'];
    }
    if (backendChartType === 'response_heatmap_chart') {
        return ['heatmap'];
    }
    return [];
};